export default __webpack_public_path__ + "static/media/riskmatrix.8ab07005.jpg";